'use client'

import { CollectionListingNoFilter } from '@/app/[locale]/collection/_components/collection-listing-no-filter'
import { CollectionContainer } from '@/components/common/collection/collection-container'
import { Tabs } from '@/components/ui/tabs'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { useState } from 'react'
import { FlashSaleBanner } from './banner'

interface FlashSaleProductsSliderProps {
  slug: string
  filterTabs?: { label: string; value: string }[]
  banner?: { desktop: string; mobile: string }
  className?: string
}

export const FlashSaleProductsSlider = ({
  slug,
  filterTabs,
  banner,
  className,
}: FlashSaleProductsSliderProps) => {
  const [selectedCollection, setSelectedCollection] = useState<string>(slug)
  const t = useTranslations()

  const onChangeTab = (value: string) => {
    setSelectedCollection(value)
  }

  const filter: { key: string; value: string }[] = [
    {
      key: 'allow_hidden',
      value: 'true',
    },
  ]

  return (
    <CollectionContainer className={cn('py-8', className)}>
      <FlashSaleBanner
        desktop={banner?.desktop || ''}
        mobile={banner?.mobile || ''}
      />
      {filterTabs && (
        <div className='flex items-center justify-between'>
          <Tabs
            className='my-4 p-0 lg:mt-6'
            triggerClassName='text-sm leading-tight font-normal font-pangea px-4 py-2 lg:px-6 lg:py-3'
            variant='filter'
            options={filterTabs || []}
            defaultValue={slug}
            onChange={onChangeTab}
          />

          <Link
            href={`/collection/${selectedCollection}`}
            className='max-md:hidden'
          >
            {' '}
            {t('button.view_all')}
          </Link>
        </div>
      )}

      <CollectionListingNoFilter
        className='mt-4'
        slug={selectedCollection}
        isHideId={true}
        filter={filter}
      />
    </CollectionContainer>
  )
}
